import { React, _ } from '../../lib';
import { LoadingSpinnerLarge } from './loading';
export const defineBox = (boxProps) => ({
    ...boxProps,
});
const BoxComponent = (props, ref) => {
    const [state, setState] = React.useState(props.state ?? props.getInitialState());
    const refObjs = _.mapValues(props.refs ?? {}, initVal => React.useRef(initVal));
    const refNew = () => ({
        props: props,
        state: state,
        refs: refObjs,
        resetState: () => {
            setState(props.getInitialState());
        },
        updateState: (newState) => {
            const newStateFull = { ...state, ...newState };
            setState(newStateFull);
            props.onUpdateState?.(newStateFull);
            props.window?.UpdateCreationState(newStateFull);
        },
    });
    React.useImperativeHandle(ref, refNew);
    const [isLoaded, setIsLoaded] = React.useState(!props.loader);
    React.useEffect(() => {
        if (props.loader) {
            props.loader(refNew()).then(() => {
                setIsLoaded(true);
            });
        }
    }, []);
    if (!isLoaded) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    return React.createElement(React.Fragment, null, props.content(refNew()));
};
export const Box = React.forwardRef(BoxComponent);
export const useBoxState = (box, key) => [
    box.state[key],
    (val) => {
        box.updateState({ [key]: val });
    },
];
//# sourceMappingURL=box.js.map